import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import { UIAccordion } from "../../../../ui";
import ZoneHeader from "./Header";
import SupervisorInfo from "./SupervisorInfo";
import StaffingSummary from "./StaffingSummary";

import "./_ZoneItem.scss";

const ZoneItem = ({ zone, index, defaultExpanded, onViewApplicants }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <UIAccordion
      hasCustomizeTitle
      expanded={expanded}
      onChange={setExpanded}
      id={`zone-${zone?.id ?? index}`}
      title={
        <ZoneHeader
          zone={zone}
          index={index}
          isExpanded={expanded}
          onViewApplicants={onViewApplicants}
        />
      }
      classNames={{ body: "p-32" }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <SupervisorInfo zone={zone} />
        </Grid>
        <Grid item xs={12} md={4}>
          <StaffingSummary zone={zone} />
        </Grid>
      </Grid>
    </UIAccordion>
  );
};

ZoneItem.propTypes = {
  zone: PropTypes.object.isRequired,
  index: PropTypes.number,
  defaultExpanded: PropTypes.bool,
  onViewApplicants: PropTypes.func,
};

ZoneItem.defaultProps = {
  index: 0,
  defaultExpanded: false,
  onViewApplicants: undefined,
};

export default ZoneItem;
